const rules = {
  agree: {
    getMessage: (field) => `Please agree to the ${field}`,
    validate(value) {
      const valid = value === true || value === 'true';
      return {
        valid,
      };
    },
  },
};

export default (Validator) => {
  Object.keys(rules).forEach(rule => Validator.extend(rule, rules[rule]));
};
